import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  AccessRequest,
  CollectionMeta,
  CreateAccessRequestInput,
  ListAccessRequestsQuery,
  MenuCatalogEntry,
} from '@neuroedge/shared';
import { apiClient, ApiClientError } from './client';

const MENUS_KEY = ['menus'] as const;
const KEY = ['access-requests'] as const;

export interface AccessRequestPage {
  items: AccessRequest[];
  meta: CollectionMeta;
}

export async function listMenuCatalog(): Promise<MenuCatalogEntry[]> {
  const res = await apiClient.getCollection<MenuCatalogEntry>('/menus');
  return res.data;
}
export const createAccessRequest = (input: CreateAccessRequestInput) =>
  apiClient.post<AccessRequest>('/access-requests', input);

export async function listAccessRequests(
  q: ListAccessRequestsQuery = {},
): Promise<AccessRequestPage> {
  const res = await apiClient.getCollection<AccessRequest>('/access-requests', {
    query: { page: q.page, pageSize: q.pageSize },
  });
  return { items: res.data, meta: res.meta };
}

export function useMenuCatalog() {
  return useQuery<MenuCatalogEntry[], ApiClientError>({
    queryKey: MENUS_KEY,
    queryFn: listMenuCatalog,
  });
}

export function useAccessRequests(query: ListAccessRequestsQuery = {}) {
  return useQuery<AccessRequestPage, ApiClientError>({
    queryKey: [...KEY, 'list', query],
    queryFn: () => listAccessRequests(query),
  });
}

export function useCreateAccessRequest() {
  const qc = useQueryClient();
  return useMutation<AccessRequest, ApiClientError, CreateAccessRequestInput>({
    mutationFn: createAccessRequest,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
      void qc.invalidateQueries({ queryKey: MENUS_KEY });
    },
  });
}
